/**
 * Step 1 — Welcome
 *
 * Spec: specs/onboarding-rebuild.md → Act 1 step 1
 *
 * Variant scaffolding retired 2026-05-14 — synthesis is the production
 * design. Other variants (basic / experimental / professional) deleted.
 */

import WelcomeSynthesis from './WelcomeHero.synthesis'

export default function WelcomeStep({ displayName = 'friend', firstName, onContinue }) {
  return (
    <WelcomeSynthesis displayName={displayName} firstName={firstName} onContinue={onContinue} />
  )
}
